module.exports = __webpack_public_path__ + "img/verify_license.21c2a305.svg";